export function getTimeoutConfig(rules = {}) {
  const maxSetsToWin = rules.maxSetsToWin || 3;
  const maxTotalSets = maxSetsToWin * 2 - 1;
  const noTTO = typeof rules.noTTOOnLastSet === "boolean" ? rules.noTTOOnLastSet : true;

  return {
    TECHNICAL: {
      type: "TECHNICAL",
      duration: 60,
      canTrigger: (currentSet, scoreA, scoreB) => {
        if (noTTO && currentSet === maxTotalSets) return false;
        return (currentSet >= 1 && currentSet <= maxTotalSets) && (scoreA === 8 || scoreA === 16 || scoreB === 8 || scoreB === 16);
      }
    },
    TEAM: {
      type: "TEAM",
      duration: 30,
      canTrigger: (timeoutsTaken) => timeoutsTaken < 2,
    }
  };
}
